"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "login-wrapper w-full flex flex-col xl:flex-row items-center justify-center" };
const _hoisted_2 = { class: "w-96 max-w-full px-4" };
const _hoisted_3 = { class: "p-8 flex items-center justify-center" };
const _hoisted_4 = ["src"];
const _hoisted_5 = ["onSubmit"];
const _hoisted_6 = {
    id: "login-sign-in-button",
    type: "submit",
    class: "w-full text-white uppercase font-bold text-lg bg-red rounded-md py-2"
};
const _hoisted_7 = { class: "text-right flex justify-end mt-5" };
const _hoisted_8 = { class: "text-right flex justify-end mt-5" };
const _hoisted_9 = ["onSubmit"];
const _hoisted_10 = {
    id: "login-reset-password-send-email-button",
    type: "submit",
    class: "w-full text-white uppercase font-bold text-lg bg-red rounded-md py-2"
};
const _hoisted_11 = ["onSubmit"];
const _hoisted_12 = {
    id: "login-reset-password-button",
    type: "submit",
    class: "w-full text-white uppercase font-bold text-lg bg-red rounded-md py-2"
};
const _hoisted_13 = ["innerHTML"];
const _hoisted_14 = ["innerHTML"];
const vue_3 = require("vue");
const vue_router_1 = require("vue-router");
const Form_1 = require("../../components/Form");
const Alert_vue_1 = __importDefault(require("../../components/Alert.vue"));
const i18n_1 = require("../../common/i18n");
const securityStore_1 = require("../../stores/security/securityStore");
const toastStore_1 = require("../../stores/toast/toastStore");
const cartsStore_1 = require("../../stores/carts/cartsStore");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'Login',
    setup(__props) {
        const cartsStore = (0, cartsStore_1.useCartsStore)();
        const route = (0, vue_router_1.useRoute)();
        const router = (0, vue_router_1.useRouter)();
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const email = (0, vue_3.ref)("");
        const password = (0, vue_3.ref)("");
        const repassword = (0, vue_3.ref)("");
        const errorMessage = (0, vue_3.ref)("");
        const isPasswordReset = (0, vue_3.ref)(false);
        const resetPasswordToken = (0, vue_3.ref)("");
        const loginPageSidebarMessage = (0, vue_3.ref)("");
        const loginPageWelcomeMessage = (0, vue_3.ref)("");
        (0, vue_3.onBeforeMount)(() => {
            resetPasswordToken.value = route.query.resetPasswordToken;
            loadLoginContents();
        });
        const loadLoginContents = () => {
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: 'api_login_contents' }).href, {
                    method: 'GET'
                }).then(loginContentsResponse => {
                    if (loginContentsResponse.loginPageWelcomeMessage) {
                        loginPageWelcomeMessage.value = loginContentsResponse.loginPageWelcomeMessage;
                    }
                    if (loginContentsResponse.loginPageSidebarMessage) {
                        loginPageSidebarMessage.value = loginContentsResponse.loginPageSidebarMessage;
                    }
                    resolve(loginContentsResponse);
                }).catch(err => {
                    reject(err);
                });
            });
        };
        const onLogin = () => {
            securityStore
                .login(router, email.value, password.value)
                .then(() => {
                if (typeof window.clarity === 'function') {
                    window.clarity("identify", email.value);
                }
                cartsStore.loadCarts(router).catch((error) => {
                    toastStore.addErrorToast(error.toString(), "login-load-carts-toast");
                });
                const redirect = router.resolve(route.query.redirect
                    ? `${route.query.redirect}`
                    : { name: "home" });
                if (redirect.name) {
                    router.replace({ name: redirect.name });
                    return;
                }
                if (redirect.path) {
                    router.replace(redirect.path);
                    return;
                }
                router.replace(redirect);
            })
                .catch((error) => {
                errorMessage.value = error.toString();
            });
        };
        const onRequestNewPassword = () => {
            securityStore
                .sendForgotPasswordEmail(router, { payload: { email: email.value } })
                .then((response) => {
                if (response.payload.sendForgotPasswordEmailResult) {
                    toastStore.addToast({
                        id: "login-email-sent-toast",
                        message: (0, i18n_1.trans)("email_sent", "Email sent!", "login"),
                        type: "success",
                        timer: 5,
                    });
                    window.setTimeout(() => {
                        window.location.reload();
                    }, 5000);
                }
            })
                .catch((error) => {
                toastStore.addErrorToast((0, i18n_1.trans)("user_not_found", "User not found", "login"), "login-user-not-found-toast");
                return false;
            });
        };
        const onAlertDismissed = () => {
            errorMessage.value = "";
        };
        const forgotPassword = () => {
            isPasswordReset.value = true;
        };
        const onResetNewPassword = () => {
            if (password.value != repassword.value) {
                toastStore.addErrorToast((0, i18n_1.trans)("incorrect_passwords", "Incorrect passwords", "login"), "login-incorrect-passwords-toast");
                return false;
            }
            securityStore
                .resetPassword(router, {
                token: resetPasswordToken.value,
                password: password.value,
                repassword: repassword.value,
            })
                .then((response) => {
                if (response.payload.resetPasswordResult) {
                    toastStore.addToast({
                        id: "login-password-reset-success-toast",
                        message: (0, i18n_1.trans)("password_reset", "Password reset successful", "login"),
                        type: "success",
                        timer: 5,
                    });
                    window.setTimeout(() => {
                        window.location.assign(router.resolve({ name: "app_login" }).href);
                    }, 5000);
                }
            }).catch(error => {
                toastStore.addErrorToast((0, i18n_1.trans)('password_reset', 'Password reset error', 'login'), 'login-password-reset-error-toast');
                return false;
            });
        };
        const redirectToRegistration = () => {
            router.push({ name: 'registration_page' });
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("h1", _hoisted_3, [
                        (0, vue_2.createElementVNode)("img", {
                            src: require('../../images/marso-logo-fekvo-red.svg'),
                            alt: "MARSO",
                            class: "w-60"
                        }, null, 8, _hoisted_4)
                    ]),
                    (errorMessage.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Alert_vue_1.default, {
                            key: 0,
                            id: "login-error-alert",
                            message: errorMessage.value,
                            icon: "",
                            dismissable: "",
                            onDismissed: onAlertDismissed
                        }, null, 8, ["message"]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (!isPasswordReset.value && !resetPasswordToken.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("form", {
                            key: 1,
                            onSubmit: (0, vue_2.withModifiers)(onLogin, ["prevent"])
                        }, [
                            (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                id: "login-email-input",
                                modelValue: email.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((email).value = $event)),
                                type: "email",
                                name: "email",
                                placeholder: (0, vue_2.unref)(i18n_1.trans)('email', 'Email', 'login'),
                                autofocus: "",
                                required: "",
                                icon: "marso-icon-user",
                                class: "my-5"
                            }, null, 8, ["modelValue", "placeholder"]),
                            (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                id: "login-password-input",
                                modelValue: password.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((password).value = $event)),
                                type: "password",
                                name: "password",
                                placeholder: (0, vue_2.unref)(i18n_1.trans)('password', 'Password', 'login'),
                                required: "",
                                icon: "marso-icon-lock",
                                class: "my-5"
                            }, null, 8, ["modelValue", "placeholder"]),
                            (0, vue_2.createElementVNode)("button", _hoisted_6, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("sign_in", "Sign in", "login")), 1),
                            (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                (0, vue_2.createElementVNode)("span", {
                                    id: "login-forgot-password-link",
                                    class: "cursor-pointer",
                                    onClick: _cache[2] || (_cache[2] = ($event) => (forgotPassword()))
                                }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("forgot_password", "Forgot password", "login")) + "* ", 1)
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_8, [
                                (0, vue_2.createElementVNode)("span", {
                                    id: "login-registration-link",
                                    class: "cursor-pointer",
                                    onClick: redirectToRegistration
                                }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('registration', 'Registration', 'login')), 1)
                            ])
                        ], 40, _hoisted_5))
                        : (0, vue_2.createCommentVNode)("", true),
                    (isPasswordReset.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("form", {
                            key: 2,
                            onSubmit: (0, vue_2.withModifiers)(onRequestNewPassword, ["prevent"])
                        }, [
                            (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                id: "login-reset-password-email-input",
                                modelValue: email.value,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((email).value = $event)),
                                type: "email",
                                name: "email",
                                placeholder: (0, vue_2.unref)(i18n_1.trans)('email', 'Email', 'login'),
                                autofocus: "",
                                required: "",
                                icon: "marso-icon-user",
                                class: "my-5"
                            }, null, 8, ["modelValue", "placeholder"]),
                            (0, vue_2.createElementVNode)("button", _hoisted_10, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("send_email", "Send email", "login")), 1)
                        ], 40, _hoisted_9))
                        : (0, vue_2.createCommentVNode)("", true),
                    (resetPasswordToken.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("form", {
                            key: 3,
                            onSubmit: (0, vue_2.withModifiers)(onResetNewPassword, ["prevent"])
                        }, [
                            (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                id: "login-reset-new-password-email-input",
                                modelValue: password.value,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((password).value = $event)),
                                type: "password",
                                name: "password",
                                placeholder: (0, vue_2.unref)(i18n_1.trans)('password', 'Password', 'login'),
                                required: "",
                                icon: "marso-icon-lock",
                                class: "my-5"
                            }, null, 8, ["modelValue", "placeholder"]),
                            (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                id: "login-reset-new-repassword-input",
                                modelValue: repassword.value,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((repassword).value = $event)),
                                type: "password",
                                name: "password",
                                placeholder: (0, vue_2.unref)(i18n_1.trans)('re_password', 'Re Password', 'login'),
                                required: "",
                                icon: "marso-icon-lock",
                                class: "my-5"
                            }, null, 8, ["modelValue", "placeholder"]),
                            (0, vue_2.createElementVNode)("button", _hoisted_12, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("reset_password", "Reset password", "login")), 1)
                        ], 40, _hoisted_11))
                        : (0, vue_2.createCommentVNode)("", true),
                    (loginPageSidebarMessage.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                            key: 4,
                            innerHTML: loginPageSidebarMessage.value,
                            class: "mt-4 text-white p-4 border-0 rounded items-center justify-between gap-4 bg-blue"
                        }, null, 8, _hoisted_13))
                        : (0, vue_2.createCommentVNode)("", true)
                ]),
                (loginPageWelcomeMessage.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                        key: 0,
                        innerHTML: loginPageWelcomeMessage.value,
                        class: "mt-4 p-4 mx-8 border-0 rounded items-center justify-between gap-4 bg-white md:w-1/2 md:max-w-4xl"
                    }, null, 8, _hoisted_14))
                    : (0, vue_2.createCommentVNode)("", true)
            ]));
        };
    }
});
